module.exports = __webpack_public_path__ + "static/media/empty.72d2fc39.svg";